
import { CustomerIndexResponseDto } from '@techgitter/contracts';

const API_BASE_URL = '/api';

export async function getCustomerIndex(signal?: AbortSignal): Promise<CustomerIndexResponseDto> {
  const endpoint = `${API_BASE_URL}/customers/index`;
  
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch customer index: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}